import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function DividerRender({ node }) {
  const style = typeof node.style === 'string' ? JSON.parse(node.style || '{}') : (node.style || {});
  const desktop = style.desktop || {};
  
  // Custom Styles via Content oder Desktop
  const borderStyle = node.content?.borderStyle || 'solid';
  const borderColor = node.content?.borderColor || 'rgba(255, 255, 255, 0.1)';
  const borderWidth = node.content?.borderWidth || '1px';
  const width = node.content?.width || '100%';

  return (
    <div style={{ display: 'flex', justifyContent: node.content?.align || 'center', width: '100%' }}>
      <hr style={{ 
        width: width, 
        border: '0', 
        borderTopStyle: borderStyle,
        borderTopColor: borderColor,
        borderTopWidth: borderWidth,
        margin: 0
      }} />
    </div>
  );
}

registry.register('Divider', {
  label: 'Trenner',
  icon: '➖', 
  category: 'basic',
  component: DividerRender,
  
  defaultProps: {
    content: {
      borderStyle: 'solid',
      borderColor: 'rgba(255, 255, 255, 0.1)',
      borderWidth: '1px',
      width: '100%',
      align: 'center'
    },
    style: {
      desktop: {
        paddingTop: '20px',
        paddingBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Linien-Stil',
          fields: [
            { name: 'content.borderStyle', label: 'Stil', type: 'select', options: ['solid', 'dashed', 'dotted', 'double'] },
            { name: 'content.borderColor', label: 'Farbe', type: 'color' },
            { name: 'content.borderWidth', label: 'Dicke (z.B. 1px, 2px)', type: 'text' },
            { name: 'content.width', label: 'Breite (z.B. 100%, 50px)', type: 'text' },
            { name: 'content.align', label: 'Ausrichtung', type: 'select', options: ['flex-start', 'center', 'flex-end'] }
          ]
        }
      ]
    }
  ]
});
